import AsyncStorage from '@react-native-async-storage/async-storage';
import { AppState, Image } from 'react-native';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { firestore } from '../firebase';
import { createSeasonalThemeStore, type SeasonalThemeSource } from './seasonalThemeStore';

const source: SeasonalThemeSource = {
  subscribe(onDocs, onError) {
    return onSnapshot(
      query(collection(firestore, 'seasonalThemes'), where('published', '==', true)),
      snapshot => onDocs(snapshot.docs.map(item => ({ id: item.id, data: item.data() as Record<string, unknown> }))),
      onError,
    );
  },
};

export const seasonalThemeStore = createSeasonalThemeStore({
  source,
  storage: AsyncStorage,
  onForeground(callback) {
    let previous = AppState.currentState;
    const subscription = AppState.addEventListener('change', next => {
      if (next === 'active' && previous !== 'active') callback();
      previous = next;
    });
    return () => subscription.remove();
  },
  async preload(urls) {
    const results = await Promise.all(urls.map(url => Image.prefetch(url).catch(() => false)));
    return results.every(Boolean);
  },
});

